import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import { RuleId } from "@/domain/gems-game/domain/lib/LatestEarnings";
import { Quest as MainQuest } from "@/domain/gems-game/domain/lib/Quest";
import { EarningType } from "@/domain/gems-game/domain/lib/Quest";
import { QuestTileType } from "@/domain/gems-game/domain/lib/TileType";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

export const tokyoBeastMainQuest = new MainQuest({
  id: RuleId.TOKYO_BEAST,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Tokyo Beast caption",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z75eXJ7c43Q3gO1B_tokyo-beast-logo.png?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z7bKPJ7c43Q3f_oD_No.1.png?auto=format,compress",
  ),
  gemsAmount: "150",
  analyticsId: "tokyo-beast-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      `<a href="https://pre.tokyo-beast.com/" target="_blank" rel="noreferrer">Pre-register</a> for Tokyo Beast's mobile launch`,
    ],
  },
  // start date should be 26th of Feb 00.00 UTC
  startDate: new Date("2025-02-26T00:00:00Z"),
  // end date should be 26th of Marth 00.00 UTC
  endDate: new Date("2025-03-26T00:00:00Z"),
  // estimate completion time should be 5 minutes
  estimateCompletionTime: "5 minutes",
  availableOn: ["iOS", "Android"],
  registerUrl: new URL("https://pre.tokyo-beast.com/"),
});

const tokyoBeastQuestsLevel0: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-wishlist-added",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Game Trailer",
    caption: "Engage with the gameplay",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/tokyo-beast/tokyobeast-onboarding-quest.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-trailer-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @TOKYOBEAST_EN on X",
    caption: "Stay updated with the latest news",
    linkUrl: "https://x.com/TOKYOBEAST_EN",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-twitter-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/tokyobeast",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-discord-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-discord",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Read the lore",
    caption: "Learn more with the Tokyo Beast explainer video",
    linkUrl: "https://www.youtube.com/watch?v=a3tf2NFE80s",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-explainer-video-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-explainer-video",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Checkout the game",
    caption: "Get ready to play Tokyo Beast",
    linkUrl: "https://pre.tokyo-beast.com/",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-download-game-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-website-download-game",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-onboarding-event",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-onboarding",
  },
];

const tokyoBeastQuestsLevel1: Quest[] = [
  {
    type: "custom",
    key: "bonus-variant-2",
    icon: "TreasureChest",
    label: "Earn an additional 150 Gems",
    caption: "Learn how to earn more Gems",
    increase: 150,
    badgeIcon: "TreasureChest",
    badgeTemplate: "Earn bonus gems <icon>",
    eventId: "this-will-never-be-completed",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-main-quest",
  },
];

const tokyoBeastQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Tokyo Beast",
    caption: "Extra Gems daily for sharing on X",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon>",
    eventId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-recurring-tweet-completed",
    ruleId: "d99f87e1-9b4e-4e40-ad64-e319a0d79335-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@TOKYOBEAST_EN",
    recurring: true,
    tweetUsername: "@TOKYOBEAST_EN",
  },
];

export const tokyoBeastQuests: QuestGroup[] = [
  {
    key: "level-0",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +50 <icon> Gems",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 50,
    quests: tokyoBeastQuestsLevel0,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems daily by posting to socials",
    },
    totalGemsGranted: 10,
    quests: tokyoBeastQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "level-1",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +150 <icon> Gems",
    hideOnCompletion: true,
    header: {
      image: "",
      description: "",
      title: "Pre-register for the mobile launch",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 150,
    quests: tokyoBeastQuestsLevel1,
  },
];
